var
    /** @type {string} */
    CSS_OPEN = 'x-ph__menu_open',
    CSS_OPEN_RIGHT = 'x-ph__menu_open_right',
    CSS_OPEN_LEFT = 'x-ph__menu_open_left',
    /** @type {HTMLElement} */
    leftColumn,
    /** @type {number} */
    menuTimer,
    css_force_right = false;

class DropdownMenu {
    constructor() {
        var self = this;

        /**
         * @param {Event} e
         */
        this.toggleMenu = function (e) {
            e.stopPropagation();
            clearTimeout(menuTimer);
            menuTimer = null;

            if (self.box.classList.contains(CSS_OPEN)) {
                self.hideMenu();
            } else {
                self.showMenu();
            }
        };

        this.hideMenu = function () {
            document.removeEventListener('click', self.hideMenu);
            self.box.classList.remove(CSS_OPEN);
            self.box.classList.remove(CSS_OPEN_RIGHT);
            self.box.classList.remove(CSS_OPEN_LEFT);
        };

        this.showMenu = function () {
            document.addEventListener('click', self.hideMenu);

            self.box.classList.add(CSS_OPEN);

            // 1200, чтобы меню влезало вправо и на основании распределения https://charts.odkl.ru/reports?report=5430&id_repository=88995&parameters=true
            // 600, чтобы запретить попапу улетать за левую границу экрана
            css_force_right = document.getAttribute('css_force_right') === true;
            if (css_force_right || (document.documentElement.clientWidth < 1200 && leftColumn.clientWidth > 600)) {
                self.box.classList.add(CSS_OPEN_RIGHT);
            } else {
                self.box.classList.add(CSS_OPEN_LEFT);
            }
        };

        this.onMouseOver = function () {
            clearTimeout(menuTimer);
            menuTimer = null;
        };

        this.onMouseOut = function () {
            clearTimeout(menuTimer);
            menuTimer = setTimeout(self.hideMenu, 4000);
        };
    }

    /**
     * @param {HTMLElement} el
     */
    activate(el) {
        var self = this;
        this.link = el.querySelector('.portal-headline__menulink');
        this.menu = el.querySelector('.portal-headline__menu');
        this.box = el;
        leftColumn = document.getElementsByClassName('portal-headline__left')[0];
        if (this.link === null || this.menu === null || this.box === null) {
            return;
        }

        this.link.addEventListener('click', self.toggleMenu, false);
        this.link.addEventListener('mouseout', self.onMouseOut, false);
        this.link.addEventListener('mouseover', self.onMouseOver, false);
        this.menu.addEventListener('mouseout', self.onMouseOut, false);
        this.menu.addEventListener('mouseover', self.onMouseOver, false);
    }

    deactivate() {
        var self = this;
        if (this.link) {
            this.link.removeEventListener('click', self.toggleMenu, false);
            this.link.removeEventListener('mouseout', self.onMouseOut, false);
            this.link.removeEventListener('mouseover', self.onMouseOut, false);
        }
        if (this.menu) {
            this.menu.removeEventListener('mouseout', self.onMouseOut, false);
            this.menu.removeEventListener('mouseover', self.onMouseOver, false);
        }
        this.link = this.menu = this.box = null;
    }
}


export default DropdownMenu;
